
<template>
  <div>
    <game-title-layout :show-top="showTop"></game-title-layout>
    <div class="tooltip_container" v-if="winType1 != 0 && winType2 > 5">
     <div class="tooltip_btn">
       {{ $t(`lang.str_respin`) }} {{winType2 - 5}}
     </div>
    </div>
    <div class="gameImgArea_4_TB">
      <div class="box" v-for="(item, index) in mapList" :key="index">
        <img :src="require('../../assets/777/' + (item.substring(0, item.indexOf(`_`))) + '.png')" alt=""
             :class="{ img_t: item.slice(-2) == '_T', img_b: item.slice(-2) == '_B', deep: winType1 != 0 }">
      </div>
    </div>
    <SlotsWinTotalLayout :show-total="true" :win-value-total="winValueTotal"></SlotsWinTotalLayout>
  </div>
</template>

<script>
import GameTitleLayout from "../common/game_detail_title.vue";
import SlotsWinTotalLayout from "./layout/slots_win_total_layout.vue";
export default {
  name: "Game5009",
  components: {
    SlotsWinTotalLayout,
    GameTitleLayout

  },
  props: {
    showTop: false,
    showTotal:false,
    lang:"",
    Phone:false,
    winValueTotal:"",
    winType1:0,
    winType2:0,
    mapList: [],
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slots/game_5009.vue